// The five control domains of the DIGU AI Security Baseline (32 controls in total).
export const DOMAINS = [
  { id: 'D1', name: 'Identity and privilege', q: 'Who is the agent, and what can it reach?', n: 7 },
  { id: 'D2', name: 'Permissions and execution boundaries', q: 'What can it run, and where?', n: 7 },
  { id: 'D3', name: 'Untrusted content', q: 'What is it allowed to treat as an instruction?', n: 5 },
  { id: 'D4', name: 'Connectivity and supply chain', q: 'What can it connect to, and send data to?', n: 5 },
  { id: 'D5', name: 'Observability and governance', q: 'What can you see, stop, and prove?', n: 8 },
];

export const TOTAL_CONTROLS = 32;

// "7 controls" on the baseline's distribution cards.
export const domainCountLabel = (n) => `${n} controls`;
